import { parseHtml } from './helpers'

export const t = (key: string, required?: boolean) =>
  `${parseHtml(window?.['containex']?.translations?.[key] ?? key)}${
    required ? '*' : ''
  }`
